import { __awaiter, __decorate, __param } from 'tslib';
import { CommonModule } from '@angular/common';
import { Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { BaseService, ErrorMessageService, DocumentValidator, UfService, DateValidator, MoneyValidator, MatchValidator, minValueValidator, MaskService, CertifiedService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeNOpenAccountProxy, ConfigService, SpeViewPreAccountProxy, Status, SpeViewOpenAccountProxy, UploadTypeEnum, PositionPhotoEnum, SpeNOpenAccountUploadProxy, UiPxSignupModule } from '@wlp/ui-px-signup';
import { SpeNOpenAccountProxy as SpeNOpenAccountProxy$1, SpeViewOpenAccountProxy as SpeViewOpenAccountProxy$1, UiPxQuizModule } from '@wlp/ui-px-quiz';
import { BehaviorSubject, of } from 'rxjs';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { tap, catchError, map } from 'rxjs/operators';

let AccountTypeService = class AccountTypeService extends BaseService {
    constructor(speNOpenAccountProxy, configService, storage, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.configService = configService;
        this.storage = storage;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
    }
    loadRegisteredAccountType() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speViewPreAccountProxy.findAccountType(this.keyPreAccount).toPromise();
        });
    }
    loadUploadsArray() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speViewPreAccountProxy.findUploads(this.keyPreAccount).toPromise();
        });
    }
    loadTypeAccount(idWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            let temporary = yield this.getTemporaryTypeAccount();
            let listType = yield this.speViewPreAccountProxy.findAccountTypeByWhiteLabel(idWhiteLabel).toPromise();
            if (temporary) {
                return listType.filter((type) => {
                    return type.typeFlow === temporary;
                });
            }
            else {
                return listType;
            }
        });
    }
    defineTypeAccount(accountPaymentType, nextStep) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speNOpenAccountProxy.createTypeAccount(this.keyPreAccount, accountPaymentType, nextStep).toPromise();
        });
    }
    accountIsMoreFiveK() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speNOpenAccountProxy.accountIsMoreFivek(this.keyPreAccount).toPromise();
        });
    }
    temporaryTypeAccount(typeflow) {
        return __awaiter(this, void 0, void 0, function* () {
            this.storage.set('temporaryTypeAccount', typeflow);
        });
    }
    getTemporaryTypeAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.storage.get('temporaryTypeAccount');
        });
    }
    getErrorMessages(err) {
        this.errorMessageService.getError(err);
    }
};
AccountTypeService.ctorParameters = () => [
    { type: SpeNOpenAccountProxy },
    { type: ConfigService },
    { type: Storage },
    { type: SpeViewPreAccountProxy },
    { type: ErrorMessageService }
];
AccountTypeService = __decorate([
    Injectable()
], AccountTypeService);

class BusinessPartnerResponse {
}

let AddPartnerService = class AddPartnerService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            fullname: [
                { type: 'required', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            docNumber: [
                { type: 'required', message: 'ONBORDING.ADD_PARTNERS.FORM.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'ONBORDING.ADD_PARTNERS.FORM.CPF.MESSAGE.CPF_NOT_VALID' }
            ]
        };
        this.businessPartnerList = [];
        this.behaviorList = new BehaviorSubject([]);
    }
    getErrorBusinessPartner(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            this.businessPartnerList = [];
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findPartners(uuid)
            .subscribe(data => {
            this.preAccountBody = data;
            if (data.businessPartner !== undefined && data.businessPartner.length > 0) {
                this.businessPartnerList = data.businessPartner;
                this.behaviorList.next(this.businessPartnerList);
            }
            else {
                this.includeFirstPartner(data);
            }
        }, err => this.errorMessageService.getError(err));
        return this.businessPartnerList;
    }
    getListPartners() {
        return this.behaviorList;
    }
    includeFirstPartner(preAccount) {
        this.preAccountBody = preAccount;
        const businessPartnerObj = new BusinessPartnerResponse();
        businessPartnerObj.fullname = preAccount.name;
        businessPartnerObj.docNumber = preAccount.cpf;
        businessPartnerObj.legalRepresentative = false;
        businessPartnerObj.attorney = false;
        businessPartnerObj.partner = false;
        businessPartnerObj.master = true;
        this.businessPartnerList.push(businessPartnerObj);
        this.preAccountBody.businessPartner = this.businessPartnerList;
        this.editForm(businessPartnerObj);
        this.sendFirstBusinessPartner(this.preAccountBody);
    }
    sendFirstBusinessPartner(preAccount) {
        this.speNOpenAccountProxy.updateBusinessPartner(this.keyPreAccount, preAccount)
            .subscribe(res => {
            // console.log('res', res);
        }, error => {
            // console.error('error', error);
        });
    }
    editForm(businessPartner) {
        this.formBusinessPartner.patchValue({
            fullname: businessPartner.fullname,
            docNumber: businessPartner.docNumber,
            legalRepresentative: businessPartner.legalRepresentative,
            attorney: businessPartner.attorney,
            partner: businessPartner.partner,
            master: businessPartner.master
        });
        return this.formBusinessPartner;
    }
    getFormBusinessPartner() {
        this.formBusinessPartner = this.formBuilder.group({
            fullname: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100)
            ])),
            docNumber: new FormControl('', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPF
            ])),
            legalRepresentative: false,
            attorney: false,
            partner: false,
            master: false
        });
        return this.formBusinessPartner;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    addNewPartner(form) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = false;
        this.preAccountBody.businessPartner.push(businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    editPartner(form, index) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = partnerItem.master;
        this.preAccountBody.businessPartner.splice(index, 1, businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    removePartner(index) {
        this.preAccountBody.businessPartner.splice(index, 1);
        this.sendBusinessPartner(this.preAccountBody);
    }
    sendBusinessPartner(preAccount) {
        this.speNOpenAccountProxy.updateBusinessPartner(this.keyPreAccount, preAccount)
            .subscribe(res => {
            this.behaviorList.next(res.businessPartner);
        }, error => {
            // console.error('error', error);
        });
    }
};
AddPartnerService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
AddPartnerService = __decorate([
    Injectable()
], AddPartnerService);

let BusinessPartnerService = class BusinessPartnerService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            fullname: [
                { type: 'required', message: 'Campo obrigatório' },
                { type: 'minlength', message: 'Deve ser maior ou igual a 6 caracteres' },
                { type: 'maxlength', message: 'Não pode exceder 100 caracteres' },
            ],
            docNumber: [
                { type: 'required', message: 'Campo obrigatório' },
                { type: 'cpfNotValid', message: 'CPF Digitado não é válido' },
            ],
        };
        this.businessPartnerList = [];
        this.behaviorList = new BehaviorSubject([]);
    }
    getErrorBusinessPartner(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.speViewPreAccountProxy.findPartners(uuid).subscribe((data) => {
            this.preAccountBody = data;
            if (data.businessPartner !== undefined && data.businessPartner.length > 0) {
                this.businessPartnerList = data.businessPartner;
                this.behaviorList.next(this.businessPartnerList);
            }
            else {
                this.includeFirstPartner(data);
            }
        }, (err) => this.errorMessageService.getError(err));
    }
    getListPartners() {
        return this.behaviorList;
    }
    includeFirstPartner(preAccount) {
        this.preAccountBody = preAccount;
        const businessPartnerObj = new BusinessPartnerResponse();
        businessPartnerObj.fullname = preAccount.name;
        businessPartnerObj.docNumber = preAccount.cpf;
        businessPartnerObj.legalRepresentative = false;
        businessPartnerObj.attorney = false;
        businessPartnerObj.partner = false;
        businessPartnerObj.master = true;
        this.businessPartnerList.push(businessPartnerObj);
        this.preAccountBody.businessPartner = this.businessPartnerList;
        this.sendBusinessPartner(this.preAccountBody);
    }
    editForm(businessPartner) {
        this.formBusinessPartner.patchValue({
            fullname: businessPartner.fullname,
            docNumber: businessPartner.docNumber,
            legalRepresentative: businessPartner.legalRepresentative,
            attorney: businessPartner.attorney,
            partner: businessPartner.partner,
            master: businessPartner.master,
        });
        return this.formBusinessPartner;
    }
    getFormBusinessPartner() {
        this.formBusinessPartner = this.formBuilder.group({
            fullname: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])),
            docNumber: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPF])),
            legalRepresentative: false,
            attorney: false,
            partner: false,
            master: false,
        });
        return this.formBusinessPartner;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    addNewPartner(form) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = false;
        this.preAccountBody.businessPartner.push(businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    editPartner(form, index) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = partnerItem.master;
        this.preAccountBody.businessPartner.splice(index, 1, businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    removePartner(index) {
        this.preAccountBody.businessPartner.splice(index, 1);
        this.sendBusinessPartner(this.preAccountBody)
            .then((res) => { })
            .catch((erro) => console.error('Ocorreu erro pra remover o Sócio ', erro));
    }
    sendBusinessPartner(preAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            this.speNOpenAccountProxy.updateBusinessPartner(this.keyPreAccount, preAccount).subscribe((res) => this.behaviorList.next(res.businessPartner), (error) => {
                // console.error('error', error);
            });
        });
    }
};
BusinessPartnerService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
BusinessPartnerService = __decorate([
    Injectable()
], BusinessPartnerService);

class ComercialAgentDataResponse {
}

class PreAccountResponse {
    constructor() {
        this.businessPartner = [];
    }
}

let ComercialAgentService = class ComercialAgentService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            nameAgent: [
                { type: 'minlength', message: 'ONBORDING.COMERCIAL_AGENT.FORM.NAME_AGENT.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', message: 'ONBORDING.COMERCIAL_AGENT.FORM.NAME_AGENT.MESSAGE.MAX_LENGTH' },
            ],
            cpfAgent: [
                { type: 'cpfNotValid', message: 'ONBORDING.COMERCIAL_AGENT.FORM.CPF_AGENT.MESSAGE.CPF_NOT_VALID' }
            ]
        };
    }
    getFormComercialAgent() {
        this.formComercialAgent = this.formBuilder.group({
            nameAgent: new FormControl('', Validators.compose([
                Validators.minLength(6),
                Validators.maxLength(100)
            ])),
            cpfAgent: new FormControl('', Validators.compose([
                DocumentValidator.isValidCPFCNPJ
            ]))
        });
        return this.formComercialAgent;
    }
    getMessageError() {
        return this.errorMessages;
    }
    sendComercialAgentData(form) {
        const comercialAgentData = this.prepareComercialAgentData(form);
        return this.speNOpenAccountProxy.updateComercialAgent(this.keyPreAccount, comercialAgentData);
    }
    getErrorComercialAgentData(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findComercialAgent(uuid)
            .subscribe(data => !!data.comercialAgentData ? this.syncForm(data.comercialAgentData) : null, err => this.errorMessageService.getError(err));
    }
    syncForm(comercialAgentData) {
        this.formComercialAgent.patchValue({
            nameAgent: comercialAgentData.nameAgent,
            cpfAgent: comercialAgentData.cpfAgent,
        });
    }
    prepareComercialAgentData(form) {
        const preAccountResponse = new PreAccountResponse();
        const comercialAgentDataResponse = new ComercialAgentDataResponse();
        const data = form.getRawValue();
        comercialAgentDataResponse.nameAgent = data.nameAgent;
        comercialAgentDataResponse.cpfAgent = data.cpfAgent;
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.comercialAgentData = comercialAgentDataResponse;
        return preAccountResponse;
    }
};
ComercialAgentService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
ComercialAgentService = __decorate([
    Injectable()
], ComercialAgentService);

class CompanyAddressResponse {
}

let CompanyAddressService = class CompanyAddressService extends BaseService {
    constructor(storage, formBuilder, ufService, configService, speNOpenAccountProxy, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.formBuilder = formBuilder;
        this.ufService = ufService;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            postalCode: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.POSTALCODE.MESSAGE.REQUIRED' },
                { type: 'minlength', message: 'ONBORDING.COMPANY_ADDRESS.FORM.POSTALCODE.MESSAGE.MIN_LENGTH', param: { minLength: 9 } },
                { type: 'pattern', message: 'ONBORDING.COMPANY_ADDRESS.FORM.POSTALCODE.MESSAGE.PATTERN' }
            ],
            address: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 200 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            numberAddress: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.NUMBER_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.NUMBER_ADDRESS.MESSAGE.MIN_LENGTH' },
            ],
            complementAddress: [
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.COMPLEMENT_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            neighborhood: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.NEIGHBORHOOD.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.NEIGHBORHOOD.MESSAGE.MAX_LENGTH' }
            ],
            cityAddress: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.CITY_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.CITY_ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.CITY_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            uf: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.UF.MESSAGE.REQUIRED' }
            ],
            country: [
            // { type: 'required', message: 'Campo obrigatório' },
            ],
        };
    }
    getErrorMessage() {
        return this.errorMessages;
    }
    getCompanyAddressForm() {
        this.formCompanyAddress = this.formBuilder.group({
            postalCode: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$')
            ])),
            address: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(200),
            ])),
            numberAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(30),
            ])),
            complementAddress: new FormControl('', Validators.compose([
                Validators.maxLength(60),
            ])),
            neighborhood: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(60)
            ])),
            cityAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(30)
            ])),
            uf: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2)
            ])),
            country: new FormControl('', Validators.compose([
            // Validators.required,
            ])),
        });
        return this.formCompanyAddress;
    }
    searchPostaCode(zipcode) {
        this.speNOpenAccountProxy
            .getCep(zipcode)
            .subscribe(data => this.updateAddress(data), error => this.errorMessageService.getError(error));
    }
    getUf() {
        return this.ufService.getListUf();
    }
    sendCompanyAddress() {
        const preAccount = this.prepareCompanyAddress(this.formCompanyAddress);
        return this.speNOpenAccountProxy.updateCompanyAddress(this.keyPreAccount, preAccount);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getErrorCompanyAddress(error) {
        this.errorMessageService.getError(error);
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findCompanyAddress(uuid)
            .subscribe(data => !!data.companyAddress ? this.syncForm(data.companyAddress) : null, err => this.errorMessageService.getError(err));
    }
    syncForm(companyAddress) {
        this.formCompanyAddress.patchValue({
            postalCode: companyAddress.postalCode,
            numberAddress: companyAddress.numberAddress,
            address: companyAddress.address,
            cityAddress: companyAddress.cityAddress,
            neighborhood: companyAddress.neighborhood,
            complementAddress: companyAddress.complementAddress,
            uf: companyAddress.uf,
            country: companyAddress.country
        });
    }
    updateAddress(address) {
        this.formCompanyAddress.patchValue({
            address: address.logradouro.toUpperCase(),
            neighborhood: address.bairro.toUpperCase(),
            cityAddress: address.localidade.toUpperCase(),
            uf: address.uf.toUpperCase(),
            country: 'br'.toUpperCase()
        });
    }
    prepareCompanyAddress(form) {
        const preAccountResponse = new PreAccountResponse();
        const companyAddress = new CompanyAddressResponse();
        const data = form.getRawValue();
        companyAddress.postalCode = data.postalCode;
        companyAddress.numberAddress = data.numberAddress;
        companyAddress.address = data.address;
        companyAddress.cityAddress = data.cityAddress;
        companyAddress.neighborhood = data.neighborhood;
        companyAddress.complementAddress = data.complementAddress;
        companyAddress.uf = data.uf;
        companyAddress.country = 'br';
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.companyAddress = companyAddress;
        return preAccountResponse;
    }
};
CompanyAddressService.ctorParameters = () => [
    { type: Storage },
    { type: FormBuilder },
    { type: UfService },
    { type: ConfigService },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: ErrorMessageService }
];
CompanyAddressService = __decorate([
    Injectable()
], CompanyAddressService);

class CompanyDataResponse {
}

let CompanyDataService = class CompanyDataService extends BaseService {
    constructor(storage, formBuilder, configService, speNOpenAccountProxy, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.formBuilder = formBuilder;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            cnpj: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.CNPJ.MESSAGE.REQUIRED' },
                {
                    type: 'cnpjNotValid',
                    message: 'ONBORDING.COMPANY_DATA.FORM.CNPJ.MESSAGE.CNPJ_NOT_VALID'
                }
            ],
            fantasyName: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.FANTASY_NAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.FANTASY_NAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.FANTASY_NAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            companyName: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            establishmentDate: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.ESTABLISHMENT_DATE.MESSAGE.REQUIRED' },
                {
                    type: 'ptDate',
                    message: 'ONBORDING.COMPANY_DATA.FORM.ESTABLISHMENT_DATE.MESSAGE.DATE_NOT_VALID'
                },
                {
                    type: 'validDate',
                    message: 'ONBORDING.COMPANY_DATA.FORM.ESTABLISHMENT_DATE.MESSAGE.DATE_NOT_VALID'
                }
            ],
            turnoverAverage: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.TURNOVER_AVERAGE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                }
            ],
            phone: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.PHONE.MESSAGE.REQUIRED' },
            ],
        };
        this.loadKey();
    }
    getErrorMessage() {
        return this.errorMessages;
    }
    getCompanyDataForm() {
        this.companyDataForm = this.formBuilder.group({
            cnpj: new FormControl('', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCNPJ
            ])),
            fantasyName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
            ])),
            companyName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
            ])),
            establishmentDate: new FormControl('', Validators.compose([
                Validators.required,
                DateValidator.ptDate,
                DateValidator.validDateMajor
            ])),
            turnoverAverage: new FormControl('R$ ', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                MoneyValidator.isValid
            ])),
            phone: new FormControl('', Validators.compose([
                Validators.required,
            ])),
        });
        return this.companyDataForm;
    }
    sendCompanyData() {
        const preAccount = this.prepareCompanyData(this.companyDataForm);
        return this.speNOpenAccountProxy.updateCompanyData(this.keyPreAccount, preAccount);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getErrorCompanyData(error) {
        this.errorMessageService.getError(error);
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findCompanyData(uuid)
            .subscribe(data => {
            !!data.companyData ? this.syncForm(data.companyData) : null,
                this.typeFlow = data.accountType.typeFlow;
        }, err => this.errorMessageService.getError(err));
    }
    syncForm(companyData) {
        this.companyDataForm.patchValue({
            cnpj: companyData.cnpj,
            companyName: companyData.companyName,
            establishmentDate: companyData.establishmentDate,
            fantasyName: companyData.fantasyName,
            phone: companyData.phone,
            turnoverAverage: companyData.turnoverAverage,
        });
    }
    prepareCompanyData(form) {
        const preAccountResponse = new PreAccountResponse();
        const companyData = new CompanyDataResponse();
        const data = form.getRawValue();
        companyData.cnpj = data.cnpj;
        companyData.companyName = data.companyName;
        companyData.establishmentDate = data.establishmentDate;
        companyData.fantasyName = data.fantasyName;
        companyData.phone = data.phone;
        companyData.turnoverAverage = data.turnoverAverage;
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.companyData = companyData;
        return preAccountResponse;
    }
};
CompanyDataService.ctorParameters = () => [
    { type: Storage },
    { type: FormBuilder },
    { type: ConfigService },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: ErrorMessageService }
];
CompanyDataService = __decorate([
    Injectable()
], CompanyDataService);

class ContractResponse {
}

let ContractService = class ContractService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
    }
    getContractForm() {
        this.contractForm = this.formBuilder.group({
            acceptContract: false
        });
        return this.contractForm;
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findContract(uuid)
            .subscribe(data => {
            return !!data.contract ? this.syncForm(data.contract) : null;
        });
    }
    syncForm(contract) {
        this.contractForm.patchValue({
            acceptContract: contract.acceptContract
        });
    }
    sendContract(form) {
        const contractData = this.prepareContract(form);
        return this.speNOpenAccountProxy.updatedContract(this.keyPreAccount, contractData);
    }
    prepareContract(form) {
        const preAccountRequest = new PreAccountResponse();
        const contractRequest = new ContractResponse();
        const data = form.getRawValue();
        contractRequest.acceptContract = data.acceptContract;
        contractRequest.dataAccept = new Date();
        preAccountRequest._id = this.keyPreAccount;
        preAccountRequest.contract = contractRequest;
        preAccountRequest.status = Status.IN_ANALYSIS_BACKOFFICE;
        return preAccountRequest;
    }
};
ContractService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService }
];
ContractService = __decorate([
    Injectable()
], ContractService);

let CreateAccountService = class CreateAccountService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService, speViewOpenAccountProxy) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.speViewOpenAccountProxy = speViewOpenAccountProxy;
        this.errorMessages = {
            fullname: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
            ],
            cpf: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.CPF.MESSAGE.CPF_NOT_VALID' },
            ],
            rg: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.RG.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.RG.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.RG.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 14 },
                },
            ],
            email: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.PATTERN' },
            ],
            emailConfirm: [
                { type: 'mustMatch', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL_CONFIRM.MESSAGE.MUST_MATCH' },
            ],
        };
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    createForm() {
        this.formCreateAccount = this.formBuilder.group({
            fullname: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(60)])),
            cpf: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPF])),
            rg: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(20)])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            emailConfirm: new FormControl(''),
        }, {
            validator: MatchValidator.mustMatch('email', 'emailConfirm'),
        });
        return this.formCreateAccount;
    }
    createPreAccount(form, uuidWhiteLabel, nextStep) {
        let preAccountResponse = this.preparePreAccount(form, uuidWhiteLabel, nextStep);
        if (this.keyPreAccount) {
            return this.speNOpenAccountProxy.updatePreAccount(this.keyPreAccount, preAccountResponse);
        }
        return this.speNOpenAccountProxy.createPreAccount(preAccountResponse);
    }
    processPreAccount(preAccount) {
        this.addItem(this.configService.getKeyForm(), preAccount._id);
        sessionStorage.setItem(this.configService.getKeyForm(), preAccount._id);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    findAccountTypeByUuid(uuid) {
        return this.speViewPreAccountProxy.findAccountType(uuid);
    }
    getPreAccount(uuid) {
        this.speViewPreAccountProxy.findPreAccount(uuid).subscribe((data) => (!!data ? this.syncForm(data, uuid) : null), (err) => this.errorMessageService.getError(err));
    }
    syncForm(preAccount, keyPreAccount) {
        this.keyPreAccount = keyPreAccount;
        this.formCreateAccount.patchValue({
            fullname: preAccount.name,
            // cpf: preAccount.cpf,
            rg: preAccount.rg,
        });
    }
    preparePreAccount(form, uuidWhiteLabel, nextStep) {
        const preAccount = new PreAccountResponse();
        let data = form.getRawValue();
        preAccount._id = this.keyPreAccount;
        preAccount.uuidWhiteLabel = uuidWhiteLabel;
        preAccount.name = data.fullname;
        preAccount.cpf = data.cpf;
        preAccount.rg = data.rg;
        preAccount.email = data.email;
        preAccount.status = Status.IN_ONBORDING;
        preAccount.lastStep = nextStep;
        return preAccount;
    }
    getErrorPreAccount(error) {
        this.errorMessageService.getError(error);
    }
    checkAccountExists(uuidWhiteLabel, cpf) {
        return this.speNOpenAccountProxy.findByWhiteLabelAndCpf(uuidWhiteLabel, cpf);
    }
    verifyEmailByIdAndIdwl(id, email, uuidWhiteLabel) {
        return this.speViewPreAccountProxy.findEmailByIdAndEmailAndWhiteLabel(id, uuidWhiteLabel, email);
    }
    verifyEmailByCpfAndIdwl(cpf, email, uuidWhiteLabel) {
        return this.speViewPreAccountProxy.findEmailByCpfAndEmailAndWhiteLabel(cpf, uuidWhiteLabel, email);
    }
    verifyEmailByIdwl(email, uuidWhiteLabel) {
        return this.speViewPreAccountProxy.findEmailByEmailAndWhiteLabel(email, uuidWhiteLabel);
    }
    loadPreAccount(uuid) {
        return this.speViewPreAccountProxy.findPreAccount(uuid).toPromise();
    }
    getLoadKeyPreAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.keyPreAccount;
        });
    }
    verifyCreateAccount(uuidWhiteLabel) {
        return this.speViewOpenAccountProxy.verifyCreateAccount(uuidWhiteLabel);
    }
};
CreateAccountService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService },
    { type: SpeViewOpenAccountProxy }
];
CreateAccountService = __decorate([
    Injectable()
], CreateAccountService);

class AddressDataResponse {
}

let PersonalAddressService = class PersonalAddressService extends BaseService {
    constructor(storage, ufService, formBuilder, configService, speNOpenAccountProxy, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.ufService = ufService;
        this.formBuilder = formBuilder;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
        this.formErrorMessages = {
            postalCode: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.POSTALCODE.MESSAGE.REQUIRED' },
                { type: 'minlength', message: 'ONBORDING.ADDRESS_MASTER.FORM.POSTALCODE.MESSAGE.MIN_LENGTH', param: { minLength: 9 } },
                { type: 'pattern', message: 'ONBORDING.ADDRESS_MASTER.FORM.POSTALCODE.MESSAGE.PATTERN' }
            ],
            address: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 200 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            numberAddress: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.NUMBER_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.NUMBER_ADDRESS.MESSAGE.MIN_LENGTH' },
            ],
            complementAddress: [
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.COMPLEMENT_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            neighborhood: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.NEIGHBORHOOD.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.NEIGHBORHOOD.MESSAGE.MAX_LENGTH' }
            ],
            cityAddress: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.CITY_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.CITY_ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.CITY_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            uf: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.UF.MESSAGE.REQUIRED' }
            ],
            country: [
            // { type: 'required', message: 'Campo obrigatório' },
            ],
        };
    }
    getFormErrorMessage() {
        return this.formErrorMessages;
    }
    getFormPersonalAddress() {
        this.formPersonalAddress = this.formBuilder.group({
            postalCode: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$')
            ])),
            address: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(200),
            ])),
            numberAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(30),
            ])),
            complementAddress: new FormControl('', Validators.compose([
                Validators.maxLength(60),
            ])),
            neighborhood: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(60)
            ])),
            cityAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(30)
            ])),
            uf: new FormControl('', Validators.compose([
                Validators.required
            ])),
            country: new FormControl('', Validators.compose([
            // Validators.required,
            ])),
        });
        return this.formPersonalAddress;
    }
    searchPostaCode(zipcode) {
        this.speNOpenAccountProxy
            .getCep(zipcode)
            .subscribe(data => this.updateAddress(data), error => this.errorMessageService.getError(error));
    }
    sendPersonalAddress() {
        const preAccount = this.preparePersonalAddress(this.formPersonalAddress);
        return this.speNOpenAccountProxy.updateAddressData(this.keyPreAccount, preAccount);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getErrorPersonalAddress(error) {
        this.errorMessageService.getError(error);
    }
    getUf() {
        return this.ufService.getListUf();
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findPersonalAddress(uuid)
            .subscribe(data => !!data.addressData ? this.syncForm(data.addressData) : null, err => this.errorMessageService.getError(err));
    }
    syncForm(addressData) {
        this.formPersonalAddress.patchValue({
            postalCode: addressData.cep,
            cityAddress: addressData.city,
            address: addressData.street,
            neighborhood: addressData.neighborhood,
            complementAddress: addressData.streetComplement,
            numberAddress: addressData.streetNumber,
            uf: addressData.uf,
            country: addressData.country
        });
    }
    updateAddress(address) {
        this.formPersonalAddress.patchValue({
            address: address.logradouro.toUpperCase(),
            neighborhood: address.bairro.toUpperCase(),
            cityAddress: address.localidade.toUpperCase(),
            uf: address.uf.toUpperCase(),
            country: 'br'.toUpperCase()
        });
    }
    preparePersonalAddress(form) {
        const preAccountResponse = new PreAccountResponse();
        const addressData = new AddressDataResponse();
        const data = form.getRawValue();
        addressData.cep = data.postalCode;
        addressData.city = data.cityAddress;
        addressData.street = data.address;
        addressData.neighborhood = data.neighborhood;
        addressData.streetComplement = data.complementAddress;
        addressData.streetNumber = data.numberAddress;
        addressData.uf = data.uf;
        addressData.country = 'br';
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.addressData = addressData;
        return preAccountResponse;
    }
};
PersonalAddressService.ctorParameters = () => [
    { type: Storage },
    { type: UfService },
    { type: FormBuilder },
    { type: ConfigService },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: ErrorMessageService }
];
PersonalAddressService = __decorate([
    Injectable()
], PersonalAddressService);

class PersonalDataResponse {
}

let PersonalDataService = class PersonalDataService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService, maskService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.maskService = maskService;
        this.errorFormMessages = {
            motherFullname: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.MOTHER_FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.DATA_MASTER.FORM.MOTHER_FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.DATA_MASTER.FORM.MOTHER_FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 50 }
                },
            ],
            birthDate: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.REQUIRED' },
                {
                    type: 'validDate',
                    message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.DATE_NOT_VALID'
                },
                {
                    type: 'ptDate',
                    message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.DATE_NOT_VALID'
                }
            ],
            monthlyIncome: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.MONTHLY_INCOME.MESSAGE.REQUIRED' },
                { type: 'minSalaryValue', message: 'ONBORDING.DATA_MASTER.FORM.MONTHLY_INCOME.MESSAGE.MIN_VALUE_INFORMED', param: { minValue: 300 } },
                {
                    type: 'minlength',
                    message: 'ONBORDING.DATA_MASTER.FORM.MONTHLY_INCOME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
            ],
            marital: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.MARITAL.MESSAGE.REQUIRED' }
            ]
        };
    }
    getPersonalData() {
        this.formPersonalData = this.formBuilder.group({
            motherFullname: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(50)
            ])),
            birthDate: new FormControl('', Validators.compose([
                Validators.required,
                DateValidator.ptDate,
                DateValidator.validDate
            ])),
            monthlyIncome: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                MoneyValidator.isValid,
                minValueValidator()
            ])),
            marital: new FormControl('', Validators.compose([
                Validators.required,
            ]))
        });
        return this.formPersonalData;
    }
    getFormErrorMessage() {
        return this.errorFormMessages;
    }
    sendPersonalData(form, nextStep) {
        const personalData = this.preparePersonalData(form);
        personalData.lastStep = nextStep;
        return this.speNOpenAccountProxy.updatePersonalData(this.keyPreAccount, personalData);
    }
    getErrorPersonalData(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    applyMaskCurrency(controlName, form) {
        this.maskService.currency(controlName, form);
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findPersonalData(uuid)
            .subscribe(data => !!data.personalData ? this.syncForm(data.personalData) : null, err => this.errorMessageService.getError(err));
    }
    syncForm(personalData) {
        this.formPersonalData.patchValue({
            birthDate: personalData.birthDay,
            marital: personalData.marital,
            motherFullname: personalData.motherName,
            monthlyIncome: personalData.monthlyIncome
        });
    }
    preparePersonalData(form) {
        const preAccountResponse = new PreAccountResponse();
        const personalDataResponse = new PersonalDataResponse();
        const data = form.getRawValue();
        const value = data.monthlyIncome.replace('R$', '', data.monthlyIncome);
        personalDataResponse.birthDay = data.birthDate;
        personalDataResponse.marital = data.marital;
        personalDataResponse.motherName = data.motherFullname;
        personalDataResponse.monthlyIncome = value;
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.personalData = personalDataResponse;
        return preAccountResponse;
    }
};
PersonalDataService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService },
    { type: MaskService }
];
PersonalDataService = __decorate([
    Injectable()
], PersonalDataService);

class ProfessionalTypeResponse {
}

let ProfessionalTypeService = class ProfessionalTypeService extends BaseService {
    constructor(storage, certifiedService, formBuilder, configService, speNOpenAccountProxy, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.certifiedService = certifiedService;
        this.formBuilder = formBuilder;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            certifiedType: [
                { type: 'required', message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_TYPE.MESSAGE.REQUIRED' },
            ],
            certifiedNumber: [
                { type: 'required', message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_NUMBER.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_NUMBER.MESSAGE.MIN_LENGTH',
                    param: { minLength: 4 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_NUMBER.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 }
                },
            ]
        };
    }
    getErrorMessage() {
        return this.errorMessages;
    }
    getProfessionalTypeForm() {
        this.professionalTypeForm = this.formBuilder.group({
            certifiedType: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            certifiedNumber: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(20),
            ])),
        });
        return this.professionalTypeForm;
    }
    sendProfessionalType() {
        const preAccount = this.prepareProfessionalType(this.professionalTypeForm);
        return this.speNOpenAccountProxy.updateProfessionalType(this.keyPreAccount, preAccount);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getErrorProfessionalType(error) {
        this.errorMessageService.getError(error);
    }
    getCertified() {
        return this.certifiedService.getListCertified();
    }
    getPreAccount(uuid) {
        this.speViewPreAccountProxy
            .findProfessionalType(uuid)
            .subscribe(data => !!data.professionalType ? this.syncForm(data.professionalType) : null, err => this.errorMessageService.getError(err));
    }
    syncForm(professionalType) {
        this.professionalTypeForm.patchValue({
            certifiedType: professionalType.certifiedType,
            certifiedNumber: professionalType.certifiedNumber,
        });
    }
    prepareProfessionalType(form) {
        const preAccountResponse = new PreAccountResponse();
        const professionalType = new ProfessionalTypeResponse();
        const data = form.getRawValue();
        professionalType.certifiedType = data.certifiedType;
        professionalType.certifiedNumber = data.certifiedNumber;
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.professionalType = professionalType;
        return preAccountResponse;
    }
};
ProfessionalTypeService.ctorParameters = () => [
    { type: Storage },
    { type: CertifiedService },
    { type: FormBuilder },
    { type: ConfigService },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: ErrorMessageService }
];
ProfessionalTypeService = __decorate([
    Injectable()
], ProfessionalTypeService);

class UploadResponse {
}

let UploadService = class UploadService extends BaseService {
    constructor(speNOpenAccountUploadProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.speNOpenAccountUploadProxy = speNOpenAccountUploadProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.listDocumentUploaded = [];
        this.preAccount = new PreAccountResponse();
    }
    uploadFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const uploadFile = this.prepareUpload(file);
            return this.speNOpenAccountUploadProxy.uploadFile(this.keyPreAccount, uploadFile).toPromise();
        });
    }
    getErroUpload(err) {
        this.errorMessageService.getError(err);
    }
    loadDocumentuploaded() {
        return __awaiter(this, void 0, void 0, function* () {
            this.listDocumentUploaded = [];
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.speViewPreAccountProxy.findUploads(this.keyPreAccount).subscribe((list) => {
                    this.setListUploded(list);
                }, (err) => {
                    this.getErroUpload(err);
                });
            }
        });
    }
    setListUploded(list) {
        this.listDocumentUploaded = list;
    }
    isDocumentUploaded(typeDocument) {
        if (!!this.listDocumentUploaded) {
            const index = this.listDocumentUploaded.findIndex((item) => item.typeDocument.toString() === typeDocument);
            return index > -1;
        }
        return false;
    }
    isDocumentReturned(typeDocument, isDocument) {
        if (!!this.listDocumentUploaded && this.listDocumentUploaded.length > 0) {
            if ((typeDocument === 'RG' || typeDocument === 'CNH') && !isDocument) {
                if (this.isDocumentUploaded('RG') || this.isDocumentUploaded('CNH')) {
                    const index = this.listDocumentUploaded.findIndex((item) => (item.typeDocument.toString() === 'RG' || item.typeDocument.toString() === 'CNH') &&
                        item.status.toUpperCase() === 'ACTIVE');
                    return !(index > -1);
                }
                return false;
            }
            if (!this.isDocumentUploaded(typeDocument)) {
                return false;
            }
            const index2 = this.listDocumentUploaded.findIndex((item) => item.typeDocument.toString() === typeDocument && item.status.toUpperCase() === 'ACTIVE');
            return !(index2 > -1);
        }
        return false;
    }
    isVisible(valid, type) {
        // const hasReturnOnList = this.isDocumentReturnedOnlist();
        // if (!valid) {
        //   return false;
        // }
        // if (valid && !hasReturnOnList) {
        //   return true;
        // }
        // if ( valid && hasReturnOnList && this.isDocumentReturned(type)) {
        //   return true;
        // }
        return valid;
    }
    getAccountType() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speViewPreAccountProxy.findAccountType(this.keyPreAccount).toPromise();
        });
    }
    createFileAccount(fileAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addItem(this.configService.getTypeUpload(), fileAccount);
            sessionStorage.setItem(this.configService.getTypeUpload(), JSON.stringify(fileAccount));
        });
    }
    loadFileTypeUpload() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadTypeUpload();
            return this.typeUpload;
        });
    }
    removeFileTypeUpload() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.removeItem(this.configService.getTypeUpload());
        });
    }
    prepareUpload(file) {
        const uploadResponse = new UploadResponse();
        uploadResponse.fileBase64 = file.fileBase64.photo;
        uploadResponse.uploadType = UploadTypeEnum[file.uploadType];
        uploadResponse.positionPhoto = PositionPhotoEnum[file.positionPhoto];
        uploadResponse.fileName = file.title;
        uploadResponse.ownership = file.ownership;
        return uploadResponse;
    }
    loadAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            this.speViewPreAccountProxy.findPreAccount(this.keyPreAccount).subscribe((res) => (this.preAccount = res), (err) => this.getErroUpload(err));
        });
    }
};
UploadService.ctorParameters = () => [
    { type: SpeNOpenAccountUploadProxy },
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
UploadService = __decorate([
    Injectable()
], UploadService);

let StepFlowService = class StepFlowService extends BaseService {
    constructor(speNOpenAccountProxy, configService, storage) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.configService = configService;
        this.storage = storage;
    }
    updateStep(step) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.speNOpenAccountProxy
                    .updateLastStep(this.keyPreAccount, step)
                    .subscribe(res => { }, err => {
                    // console.error(err);
                });
            }
        });
    }
};
StepFlowService.ctorParameters = () => [
    { type: SpeNOpenAccountProxy },
    { type: ConfigService },
    { type: Storage }
];
StepFlowService = __decorate([
    Injectable()
], StepFlowService);

let PartnersService = class PartnersService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            fullname: [
                { type: 'required', message: 'Campo obrigatório' },
                { type: 'minlength', message: 'Deve ser maior ou igual a 6 caracteres' },
                { type: 'maxlength', message: 'Não pode exceder 100 caracteres' },
            ],
            docNumber: [
                { type: 'required', message: 'Campo obrigatório' },
                { type: 'cpfNotValid', message: 'CPF Digitado não é válido' }
            ]
        };
        this.businessPartnerList = [];
        this.behaviorList = new BehaviorSubject([]);
        this.status = new BehaviorSubject(null);
    }
    getErrorBusinessPartner(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (this.keyPreAccount != null) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.speViewPreAccountProxy
            .findPartners(uuid)
            .pipe(tap(data => {
            this.preAccountBody = data;
            if (data.businessPartner !== undefined && data.businessPartner.length > 0) {
                this.businessPartnerList = data.businessPartner;
                this.behaviorList.next(this.businessPartnerList);
            }
            else {
                this.includeFirstPartner(data);
            }
        }), catchError(res => {
            this.errorMessageService.getError(res);
            return of(false);
        }))
            .subscribe();
    }
    getListPartners() {
        return this.behaviorList;
    }
    getStatus() {
        return this.status;
    }
    includeFirstPartner(preAccount) {
        this.preAccountBody = preAccount;
        const businessPartnerObj = new BusinessPartnerResponse();
        businessPartnerObj.fullname = preAccount.name;
        businessPartnerObj.docNumber = preAccount.cpf;
        businessPartnerObj.legalRepresentative = false;
        businessPartnerObj.attorney = false;
        businessPartnerObj.partner = false;
        businessPartnerObj.master = true;
        this.businessPartnerList.push(businessPartnerObj);
        this.preAccountBody.businessPartner = this.businessPartnerList;
        return this.sendBusinessPartner(this.preAccountBody);
    }
    editForm(businessPartner) {
        this.formBusinessPartner.patchValue({
            fullname: businessPartner.fullname,
            docNumber: businessPartner.docNumber,
            legalRepresentative: businessPartner.legalRepresentative,
            attorney: businessPartner.attorney,
            partner: businessPartner.partner,
            master: businessPartner.master
        });
        return this.formBusinessPartner;
    }
    getFormBusinessPartner() {
        this.formBusinessPartner = this.formBuilder.group({
            fullname: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100)
            ])),
            docNumber: new FormControl('', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPF
            ])),
            legalRepresentative: false,
            attorney: false,
            partner: false,
            master: false
        });
        return this.formBusinessPartner;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    addNewPartner(form) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = false;
        this.preAccountBody.businessPartner.push(businessPartnerResponse);
        return this.sendBusinessPartner(this.preAccountBody);
    }
    editPartner(form, index) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = partnerItem.master;
        this.preAccountBody.businessPartner.splice(index, 1, businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    removePartner(index) {
        this.preAccountBody.businessPartner.splice(index, 1);
        return this.sendBusinessPartner(this.preAccountBody);
    }
    sendBusinessPartner(preAccount) {
        this.status.next(true);
        this.speNOpenAccountProxy.updateBusinessPartner(this.keyPreAccount, preAccount)
            .pipe(tap(res => {
            this.behaviorList.next(res.businessPartner);
            this.status.next(false);
        }), catchError(res => {
            this.status.next(false);
            return of(false);
        }))
            .subscribe();
    }
    initializeBehaviourList() {
        this.behaviorList = new BehaviorSubject([]);
        this.status = new BehaviorSubject(null);
        this.businessPartnerList = [];
    }
};
PartnersService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
PartnersService = __decorate([
    Injectable()
], PartnersService);

let StatusAccountService = class StatusAccountService extends BaseService {
    constructor(speViewPreAccountProxy, storage, configService) {
        super(storage, configService);
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
    }
    loadStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speViewPreAccountProxy.findStatusById(this.keyPreAccount).toPromise();
        });
    }
    getTitle(status) {
        if (status === Status.IN_ANALYSIS_COMPLIANCE ||
            status === Status.APPROVED_COMPLIANCE ||
            status === Status.IN_ANALYSIS_BACKOFFICE ||
            status === Status.APPROVED_BACKOFFICE ||
            status === Status.IN_ANALYSIS_TOPAZIO ||
            status === Status.APPROVED_TOPAZIO ||
            status === Status.VALIDATION_PENDENT ||
            status === Status.VALIDATION_ANALYSIS) {
            return 'ONBORDING.STATUS_ACCOUNT.IN_ANALYSIS.DESCRIPTION_TITLE';
        }
        else if (status === Status.DOCUMENT_LEGAL_PERSON_REPROVED ||
            status === Status.DOCUMENT_PHYSICAL_PERSON_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.DOCUMENT_INVALID.DESCRIPTION_TITLE';
        }
        else if (status === Status.REGISTRATION_DATA_LEGAL_PERSON_INVALID ||
            status === Status.REGISTRATION_DATA_PHYSICAL_PERSON_INVALID) {
            return 'ONBORDING.STATUS_ACCOUNT.DATA_INVALID.DESCRIPTION_TITLE';
        }
        else if (status === Status.REPROVED || status === Status.VALIDATION_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.REPROVED.DESCRIPTION_TITLE';
        }
        else if (status === Status.FINISHED) {
            return 'ONBORDING.STATUS_ACCOUNT.APPROVED.DESCRIPTION_TITLE';
        }
    }
    getDescription(status) {
        if (status === Status.IN_ANALYSIS_COMPLIANCE ||
            status === Status.APPROVED_COMPLIANCE ||
            status === Status.IN_ANALYSIS_BACKOFFICE ||
            status === Status.APPROVED_BACKOFFICE ||
            status === Status.IN_ANALYSIS_TOPAZIO ||
            status === Status.APPROVED_TOPAZIO ||
            status === Status.VALIDATION_PENDENT ||
            status === Status.VALIDATION_ANALYSIS) {
            return 'ONBORDING.STATUS_ACCOUNT.IN_ANALYSIS.DESCRIPTION';
        }
        else if (status === Status.DOCUMENT_LEGAL_PERSON_REPROVED ||
            status === Status.DOCUMENT_PHYSICAL_PERSON_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.DOCUMENT_INVALID.DESCRIPTION';
        }
        else if (status === Status.REGISTRATION_DATA_LEGAL_PERSON_INVALID ||
            status === Status.REGISTRATION_DATA_PHYSICAL_PERSON_INVALID) {
            return 'ONBORDING.STATUS_ACCOUNT.DATA_INVALID.DESCRIPTION';
        }
        else if (status === Status.REPROVED || status === Status.VALIDATION_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.REPROVED.DESCRIPTION';
        }
        else if (status === Status.FINISHED) {
            return 'ONBORDING.STATUS_ACCOUNT.APPROVED.DESCRIPTION';
        }
    }
    getTextButton(status) {
        if (status === Status.IN_ANALYSIS_COMPLIANCE ||
            status === Status.APPROVED_COMPLIANCE ||
            status === Status.IN_ANALYSIS_BACKOFFICE ||
            status === Status.APPROVED_BACKOFFICE ||
            status === Status.IN_ANALYSIS_TOPAZIO ||
            status === Status.APPROVED_TOPAZIO ||
            status === Status.VALIDATION_PENDENT ||
            status === Status.VALIDATION_ANALYSIS) {
            return 'ONBORDING.STATUS_ACCOUNT.IN_ANALYSIS.BUTTON';
        }
        else if (status === Status.DOCUMENT_LEGAL_PERSON_REPROVED ||
            status === Status.DOCUMENT_PHYSICAL_PERSON_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.DOCUMENT_INVALID.BUTTON';
        }
        else if (status === Status.REGISTRATION_DATA_LEGAL_PERSON_INVALID ||
            status === Status.REGISTRATION_DATA_PHYSICAL_PERSON_INVALID) {
            return 'ONBORDING.STATUS_ACCOUNT.DATA_INVALID.BUTTON';
        }
        else if (status === Status.REPROVED || status === Status.VALIDATION_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.REPROVED.BUTTON';
        }
        else if (status === Status.FINISHED) {
            return 'ONBORDING.STATUS_ACCOUNT.APPROVED.BUTTON';
        }
    }
};
StatusAccountService.ctorParameters = () => [
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService }
];
StatusAccountService = __decorate([
    Injectable()
], StatusAccountService);

let UserInterestsService = class UserInterestsService extends BaseService {
    constructor(speNOpenAccountProxy, speViewPreAccountProxy, storage, configService) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.preAccount = new PreAccountResponse();
        this.loadKey();
    }
    /**
     * retorna os dados do usuario atual
     */
    getUserData() {
        return this.speViewPreAccountProxy.findPreAccount(this.keyPreAccount);
    }
    /**
     * retorna a lista de interesses cadastrados no white label
     * @param uuidWL
     */
    getInterests(uuidWL) {
        return this.speViewPreAccountProxy.findInterests(uuidWL)
            .pipe(map((result) => {
            return result.filter(res => res.deleted === 0);
        }));
    }
    /**
     * cadastra os produtos de interesse do usuario
     * @param userid
     * @param interests
     */
    addUserInterest(userid, interests) {
        return this.speNOpenAccountProxy.addUserInterest(userid, interests);
    }
};
UserInterestsService.ctorParameters = () => [
    { type: SpeNOpenAccountProxy },
    { type: SpeViewPreAccountProxy },
    { type: Storage },
    { type: ConfigService }
];
UserInterestsService = __decorate([
    Injectable()
], UserInterestsService);

let QuizService = class QuizService extends BaseService {
    constructor(speNOpenAccountProxy, speViewNOpenAccountProxy, configService, storage) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewNOpenAccountProxy = speViewNOpenAccountProxy;
        this.configService = configService;
        this.storage = storage;
    }
    // sendPersonalData(): Observable<PreAccount> {
    //   const personalData = this.preparePersonalData(form);
    //   personalData.lastStep = nextStep;
    //   return this.speNOpenAccountProxy.updatePersonalData(this.keyPreAccount, personalData);
    // }
    answerQuiz(body) {
        return this.speNOpenAccountProxy.answerQuiz(body);
    }
    getCampaing(idDataFlow) {
        return this.speViewNOpenAccountProxy.getCampaing(idDataFlow);
    }
    verifyAccountQuiz(body) {
        return this.speViewNOpenAccountProxy.verifyAccountQuiz(body);
    }
    checkOcr(body) {
        return this.speNOpenAccountProxy.checkOcr(body);
    }
    attPreAccount(id, data) {
        return this.speNOpenAccountProxy.attPreAccount(id, data);
    }
    attPersonalData(id, data) {
        return this.speNOpenAccountProxy.attPersonalData(id, data);
    }
    attAddressData(id, data) {
        return this.speNOpenAccountProxy.attAddressData(id, data);
    }
};
QuizService.ctorParameters = () => [
    { type: SpeNOpenAccountProxy$1 },
    { type: SpeViewOpenAccountProxy$1 },
    { type: ConfigService },
    { type: Storage }
];
QuizService = __decorate([
    Injectable()
], QuizService);

var UiBsSignupModule_1;
let UiBsSignupModule = UiBsSignupModule_1 = class UiBsSignupModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsSignupModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsSignupModule.ctorParameters = () => [
    { type: UiBsSignupModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsSignupModule = UiBsSignupModule_1 = __decorate([
    NgModule({
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            // BrowserModule,
            UiBsTranslateModule,
            UiPxSignupModule,
            UiPxQuizModule,
            UiBsUtilModule,
            RxReactiveFormsModule
        ],
        providers: [
            CreateAccountService,
            PersonalDataService,
            PersonalAddressService,
            CompanyAddressService,
            ContractService,
            CompanyDataService,
            ComercialAgentService,
            BusinessPartnerService,
            ProfessionalTypeService,
            ProfessionalTypeService,
            AccountTypeService,
            UploadService,
            AddPartnerService,
            PartnersService,
            StepFlowService,
            StatusAccountService,
            UserInterestsService,
            QuizService
        ],
        exports: [RxReactiveFormsModule]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsSignupModule);

class FileAccount {
}

class AccountPaymentTypeResponse {
}

/*
 * Public API Surface of ui-c-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountPaymentTypeResponse, AccountTypeService, AddPartnerService, BusinessPartnerService, ComercialAgentService, CompanyAddressService, CompanyDataService, ContractService, CreateAccountService, FileAccount, PartnersService, PersonalAddressService, PersonalDataService, PreAccountResponse, ProfessionalTypeService, QuizService, StatusAccountService, StepFlowService, UiBsSignupModule, UploadService, UserInterestsService };
//# sourceMappingURL=wlp-ui-bs-signup.js.map
